export interface DemoLink {
  platform: string;
  label: string;
  url: string;
  sortOrder: number;
}

export interface DemoProfileData {
  slug: string;
  category: "who" | "usecase";
  pageBadge: string;
  username: string;
  name: string;
  bio: string;
  location: string;
  avatarInitial: string;
  avatarColor: string;
  coverFrom: string;
  coverTo: string;
  profileType: string;
  themeId: string;
  themeImageUrl: string | null;
  links: DemoLink[];
  totalScans: number;
  todayScans: number;
  weekScans: number;
  monthScans: number;
  profileFormData: {
    name: string;
    bio: string;
    email: string;
    location: string;
    website: string;
    phone: string;
    avatarUrl: string;
  };
}

export const DEMO_PROFILES: DemoProfileData[] = [
  // ── WHO IT'S FOR ──────────────────────────────────────
  {
    slug: "brands",
    category: "who",
    pageBadge: "For Brands",
    username: "globalbrandco",
    name: "GlobalBrand Co.",
    bio: "Building iconic brand experiences worldwide since 2015. Official digital hub.",
    location: "New York, NY",
    avatarInitial: "G",
    avatarColor: "bg-violet-600",
    coverFrom: "from-violet-600",
    coverTo: "to-purple-700",
    profileType: "brand",
    themeId: "personal-personal-brand-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Official Website", url: "https://example.com", sortOrder: 1 },
      { platform: "instagram", label: "Instagram", url: "https://instagram.com/globalbrandco", sortOrder: 2 },
      { platform: "linkedin", label: "LinkedIn", url: "https://linkedin.com/company/globalbrand", sortOrder: 3 },
      { platform: "youtube", label: "YouTube Channel", url: "https://youtube.com/@globalbrand", sortOrder: 4 },
      { platform: "twitter", label: "X (Twitter)", url: "https://x.com/globalbrand", sortOrder: 5 },
      { platform: "facebook", label: "Facebook Page", url: "https://facebook.com/globalbrandco", sortOrder: 6 },
    ],
    totalScans: 12840,
    todayScans: 47,
    weekScans: 320,
    monthScans: 1280,
    profileFormData: {
      name: "GlobalBrand Co.",
      bio: "Building iconic brand experiences worldwide since 2015. Official digital hub.",
      email: "connect@globalbrand.com",
      location: "New York, NY",
      website: "https://example.com",
      phone: "+1 212 555 0100",
      avatarUrl: "",
    },
  },
  {
    slug: "businesses",
    category: "who",
    pageBadge: "For Businesses",
    username: "elitecafeblr",
    name: "Elite Café",
    bio: "Premium coffee & all-day brunch. Visit us for your daily fix ☕",
    location: "Bangalore, India",
    avatarInitial: "E",
    avatarColor: "bg-amber-600",
    coverFrom: "from-amber-500",
    coverTo: "to-orange-600",
    profileType: "restaurant",
    themeId: "food-fine-dining-bold",
    themeImageUrl: null,
    links: [
      { platform: "whatsapp", label: "WhatsApp Order", url: "https://wa.me/919876543210", sortOrder: 1 },
      { platform: "phone", label: "Call Us", url: "tel:+919876543210", sortOrder: 2 },
      { platform: "location", label: "Find Us on Map", url: "https://maps.google.com/?q=MG+Road+Bangalore", sortOrder: 3 },
      { platform: "website", label: "View Our Menu", url: "https://example.com/menu", sortOrder: 4 },
      { platform: "instagram", label: "Instagram", url: "https://instagram.com/elitecafe_blr", sortOrder: 5 },
      { platform: "facebook", label: "Facebook", url: "https://facebook.com/elitecafe", sortOrder: 6 },
    ],
    totalScans: 8420,
    todayScans: 35,
    weekScans: 218,
    monthScans: 870,
    profileFormData: {
      name: "Elite Café",
      bio: "Premium coffee & all-day brunch. Visit us for your daily fix ☕",
      email: "hello@elitecafe.in",
      location: "Bangalore, India",
      website: "https://example.com",
      phone: "+91 98765 43210",
      avatarUrl: "",
    },
  },
  {
    slug: "products",
    category: "who",
    pageBadge: "For Products",
    username: "runmaxpro",
    name: "RunMax Pro",
    bio: "Engineered for performance. Scan to explore shoe tech, warranty & 24/7 support.",
    location: "Portland, OR",
    avatarInitial: "R",
    avatarColor: "bg-rose-600",
    coverFrom: "from-rose-600",
    coverTo: "to-orange-600",
    profileType: "ecommerce",
    themeId: "retail-fashion-boutique-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Shop Now", url: "https://example.com/shop", sortOrder: 1 },
      { platform: "whatsapp", label: "Customer Support", url: "https://wa.me/1234567890", sortOrder: 2 },
      { platform: "email", label: "Email Support", url: "mailto:support@runmax.com", sortOrder: 3 },
      { platform: "youtube", label: "Product Videos", url: "https://youtube.com/@runmaxpro", sortOrder: 4 },
      { platform: "instagram", label: "Instagram", url: "https://instagram.com/runmaxpro", sortOrder: 5 },
    ],
    totalScans: 5640,
    todayScans: 22,
    weekScans: 145,
    monthScans: 580,
    profileFormData: {
      name: "RunMax Pro",
      bio: "Engineered for performance. Scan to explore shoe tech, warranty & 24/7 support.",
      email: "support@runmax.com",
      location: "Portland, OR",
      website: "https://example.com",
      phone: "+1 503 555 0199",
      avatarUrl: "",
    },
  },
  {
    slug: "local-businesses",
    category: "who",
    pageBadge: "For Local Businesses",
    username: "cornerbrewatx",
    name: "Corner Brew",
    bio: "Your neighbourhood's favourite coffee spot. Open 7am–9pm daily.",
    location: "Austin, TX",
    avatarInitial: "C",
    avatarColor: "bg-amber-800",
    coverFrom: "from-amber-700",
    coverTo: "to-orange-800",
    profileType: "restaurant",
    themeId: "food-fine-dining-bold",
    themeImageUrl: null,
    links: [
      { platform: "phone", label: "Call to Reserve", url: "tel:+15125551234", sortOrder: 1 },
      { platform: "whatsapp", label: "WhatsApp Us", url: "https://wa.me/15125551234", sortOrder: 2 },
      { platform: "location", label: "Get Directions", url: "https://maps.google.com/?q=Austin+TX", sortOrder: 3 },
      { platform: "website", label: "Our Menu", url: "https://example.com/menu", sortOrder: 4 },
      { platform: "instagram", label: "Instagram", url: "https://instagram.com/cornerbrewatx", sortOrder: 5 },
    ],
    totalScans: 3210,
    todayScans: 18,
    weekScans: 112,
    monthScans: 420,
    profileFormData: {
      name: "Corner Brew",
      bio: "Your neighbourhood's favourite coffee spot. Open 7am–9pm daily.",
      email: "hi@cornerbrew.com",
      location: "Austin, TX",
      website: "https://example.com",
      phone: "+1 512 555 1234",
      avatarUrl: "",
    },
  },
  {
    slug: "celebrities",
    category: "who",
    pageBadge: "For Celebrities",
    username: "alexriveraofficial",
    name: "Alex Rivera",
    bio: "Singer · Songwriter · Producer. New album 'Echoes' out now! 🎵",
    location: "Los Angeles, CA",
    avatarInitial: "A",
    avatarColor: "bg-pink-600",
    coverFrom: "from-pink-600",
    coverTo: "to-purple-700",
    profileType: "celebrity",
    themeId: "personal-influencer-artist-bold",
    themeImageUrl: null,
    links: [
      { platform: "instagram", label: "Instagram", url: "https://instagram.com/alexriveraofficial", sortOrder: 1 },
      { platform: "youtube", label: "YouTube", url: "https://youtube.com/@alexrivera", sortOrder: 2 },
      { platform: "tiktok", label: "TikTok", url: "https://tiktok.com/@alexrivera", sortOrder: 3 },
      { platform: "twitter", label: "X (Twitter)", url: "https://x.com/alexrivera", sortOrder: 4 },
      { platform: "website", label: "Official Site", url: "https://example.com", sortOrder: 5 },
      { platform: "facebook", label: "Facebook", url: "https://facebook.com/alexriveraofficial", sortOrder: 6 },
    ],
    totalScans: 24600,
    todayScans: 128,
    weekScans: 890,
    monthScans: 3400,
    profileFormData: {
      name: "Alex Rivera",
      bio: "Singer · Songwriter · Producer. New album 'Echoes' out now! 🎵",
      email: "booking@alexrivera.com",
      location: "Los Angeles, CA",
      website: "https://example.com",
      phone: "+1 310 555 0199",
      avatarUrl: "",
    },
  },
  {
    slug: "professionals",
    category: "who",
    pageBadge: "For Professionals",
    username: "drpriyasharma",
    name: "Dr. Priya Sharma",
    bio: "Management Consultant & Executive Coach. Helping leaders build high-performance teams.",
    location: "Mumbai, India",
    avatarInitial: "P",
    avatarColor: "bg-teal-600",
    coverFrom: "from-teal-600",
    coverTo: "to-emerald-700",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "linkedin", label: "LinkedIn Profile", url: "https://linkedin.com/in/drpriyasharma", sortOrder: 1 },
      { platform: "email", label: "Book a Session", url: "mailto:priya@sharmacoach.com", sortOrder: 2 },
      { platform: "phone", label: "Call / WhatsApp", url: "tel:+919876543210", sortOrder: 3 },
      { platform: "website", label: "My Website", url: "https://example.com", sortOrder: 4 },
      { platform: "twitter", label: "X (Twitter)", url: "https://x.com/drpriyasharma", sortOrder: 5 },
    ],
    totalScans: 6200,
    todayScans: 14,
    weekScans: 98,
    monthScans: 390,
    profileFormData: {
      name: "Dr. Priya Sharma",
      bio: "Management Consultant & Executive Coach. Helping leaders build high-performance teams.",
      email: "priya@sharmacoach.com",
      location: "Mumbai, India",
      website: "https://example.com",
      phone: "+91 98765 43210",
      avatarUrl: "",
    },
  },

  // ── USE CASES ──────────────────────────────────────────
  {
    slug: "business-card",
    category: "usecase",
    pageBadge: "Use Case: Business Cards",
    username: "jameschen",
    name: "James Chen",
    bio: "Regional Sales Director | Building partnerships that drive growth across APAC.",
    location: "Singapore",
    avatarInitial: "J",
    avatarColor: "bg-blue-600",
    coverFrom: "from-blue-600",
    coverTo: "to-indigo-700",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "linkedin", label: "LinkedIn", url: "https://linkedin.com/in/jameschenapac", sortOrder: 1 },
      { platform: "phone", label: "+65 9876 5432", url: "tel:+6598765432", sortOrder: 2 },
      { platform: "email", label: "Email Me", url: "mailto:james.chen@example.com", sortOrder: 3 },
      { platform: "whatsapp", label: "WhatsApp", url: "https://wa.me/6598765432", sortOrder: 4 },
      { platform: "website", label: "Portfolio", url: "https://example.com/james", sortOrder: 5 },
    ],
    totalScans: 4800,
    todayScans: 12,
    weekScans: 84,
    monthScans: 340,
    profileFormData: {
      name: "James Chen",
      bio: "Regional Sales Director | Building partnerships that drive growth across APAC.",
      email: "james.chen@example.com",
      location: "Singapore",
      website: "https://example.com/james",
      phone: "+65 9876 5432",
      avatarUrl: "",
    },
  },
  {
    slug: "product-packaging",
    category: "usecase",
    pageBadge: "Use Case: Product Packaging",
    username: "luxskinco",
    name: "LuxSkin Co.",
    bio: "Clean beauty, scientifically proven. Scan for ingredient guide, tutorials & reorder.",
    location: "London, UK",
    avatarInitial: "L",
    avatarColor: "bg-rose-500",
    coverFrom: "from-rose-500",
    coverTo: "to-pink-700",
    profileType: "ecommerce",
    themeId: "retail-fashion-boutique-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Reorder Online", url: "https://example.com/shop", sortOrder: 1 },
      { platform: "youtube", label: "How-To Tutorials", url: "https://youtube.com/@luxskinco", sortOrder: 2 },
      { platform: "whatsapp", label: "Beauty Advisor", url: "https://wa.me/441234567890", sortOrder: 3 },
      { platform: "instagram", label: "Instagram", url: "https://instagram.com/luxskinco", sortOrder: 4 },
      { platform: "email", label: "Product Support", url: "mailto:hello@luxskin.com", sortOrder: 5 },
    ],
    totalScans: 3840,
    todayScans: 16,
    weekScans: 108,
    monthScans: 432,
    profileFormData: {
      name: "LuxSkin Co.",
      bio: "Clean beauty, scientifically proven. Scan for ingredient guide, tutorials & reorder.",
      email: "hello@luxskin.com",
      location: "London, UK",
      website: "https://example.com",
      phone: "+44 12345 67890",
      avatarUrl: "",
    },
  },
  {
    slug: "storefront",
    category: "usecase",
    pageBadge: "Use Case: Storefront",
    username: "modastore",
    name: "Moda Store",
    bio: "Contemporary fashion for the modern wardrobe. Step inside & discover your style.",
    location: "Milan, Italy",
    avatarInitial: "M",
    avatarColor: "bg-slate-800",
    coverFrom: "from-slate-700",
    coverTo: "to-gray-900",
    profileType: "retail",
    themeId: "retail-fashion-boutique-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Shop Online", url: "https://example.com/shop", sortOrder: 1 },
      { platform: "whatsapp", label: "Style Enquiry", url: "https://wa.me/390123456789", sortOrder: 2 },
      { platform: "instagram", label: "New Arrivals", url: "https://instagram.com/modastore", sortOrder: 3 },
      { platform: "location", label: "Store Map", url: "https://maps.google.com/?q=Milan", sortOrder: 4 },
      { platform: "phone", label: "Call Store", url: "tel:+390123456789", sortOrder: 5 },
    ],
    totalScans: 5120,
    todayScans: 28,
    weekScans: 192,
    monthScans: 768,
    profileFormData: {
      name: "Moda Store",
      bio: "Contemporary fashion for the modern wardrobe. Step inside & discover your style.",
      email: "info@modastore.it",
      location: "Milan, Italy",
      website: "https://example.com",
      phone: "+39 012 345 6789",
      avatarUrl: "",
    },
  },
  {
    slug: "restaurant-menu",
    category: "usecase",
    pageBadge: "Use Case: Restaurant Menu",
    username: "spicegarden",
    name: "Spice Garden",
    bio: "Authentic South Indian cuisine. Vegetarian paradise. Scan to see today's specials 🌶",
    location: "Chennai, India",
    avatarInitial: "S",
    avatarColor: "bg-orange-600",
    coverFrom: "from-orange-600",
    coverTo: "to-red-700",
    profileType: "restaurant",
    themeId: "food-fine-dining-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "View Full Menu", url: "https://example.com/menu", sortOrder: 1 },
      { platform: "whatsapp", label: "Reserve a Table", url: "https://wa.me/914412345678", sortOrder: 2 },
      { platform: "phone", label: "Call Us", url: "tel:+914412345678", sortOrder: 3 },
      { platform: "location", label: "Find Us", url: "https://maps.google.com/?q=Chennai", sortOrder: 4 },
      { platform: "instagram", label: "Food Gallery", url: "https://instagram.com/spicegardenche", sortOrder: 5 },
    ],
    totalScans: 9200,
    todayScans: 41,
    weekScans: 287,
    monthScans: 1148,
    profileFormData: {
      name: "Spice Garden",
      bio: "Authentic South Indian cuisine. Vegetarian paradise. Scan to see today's specials 🌶",
      email: "reservations@spicegarden.in",
      location: "Chennai, India",
      website: "https://example.com",
      phone: "+91 44 1234 5678",
      avatarUrl: "",
    },
  },
  {
    slug: "event-pass",
    category: "usecase",
    pageBadge: "Use Case: Event Pass",
    username: "techconf2026",
    name: "TechConf 2026",
    bio: "India's largest tech conference. 3 days, 80+ speakers, 5,000 attendees. June 14–16.",
    location: "Hyderabad, India",
    avatarInitial: "T",
    avatarColor: "bg-indigo-700",
    coverFrom: "from-indigo-600",
    coverTo: "to-blue-800",
    profileType: "event",
    themeId: "services-event-planner-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Conference Schedule", url: "https://example.com/schedule", sortOrder: 1 },
      { platform: "whatsapp", label: "Attendee Support", url: "https://wa.me/914012345678", sortOrder: 2 },
      { platform: "location", label: "Venue Map", url: "https://maps.google.com/?q=HITEX+Hyderabad", sortOrder: 3 },
      { platform: "instagram", label: "Event Updates", url: "https://instagram.com/techconf2026", sortOrder: 4 },
      { platform: "linkedin", label: "Event Page", url: "https://linkedin.com/events/techconf2026", sortOrder: 5 },
    ],
    totalScans: 7840,
    todayScans: 62,
    weekScans: 430,
    monthScans: 1720,
    profileFormData: {
      name: "TechConf 2026",
      bio: "India's largest tech conference. 3 days, 80+ speakers, 5,000 attendees. June 14–16.",
      email: "info@techconf.in",
      location: "Hyderabad, India",
      website: "https://example.com",
      phone: "+91 40 1234 5678",
      avatarUrl: "",
    },
  },
  {
    slug: "social-hub",
    category: "usecase",
    pageBadge: "Use Case: Social Hub",
    username: "miacreative",
    name: "Mia Creative",
    bio: "Content creator · Lifestyle & travel. Collab enquiries below 🌍✨",
    location: "Dubai, UAE",
    avatarInitial: "M",
    avatarColor: "bg-fuchsia-600",
    coverFrom: "from-fuchsia-600",
    coverTo: "to-pink-700",
    profileType: "celebrity",
    themeId: "personal-influencer-artist-bold",
    themeImageUrl: null,
    links: [
      { platform: "instagram", label: "Instagram (850K)", url: "https://instagram.com/miacreative", sortOrder: 1 },
      { platform: "tiktok", label: "TikTok (2.1M)", url: "https://tiktok.com/@miacreative", sortOrder: 2 },
      { platform: "youtube", label: "YouTube", url: "https://youtube.com/@miacreative", sortOrder: 3 },
      { platform: "whatsapp", label: "Collab Enquiry", url: "https://wa.me/971501234567", sortOrder: 4 },
      { platform: "email", label: "Business Email", url: "mailto:mia@creativeagency.com", sortOrder: 5 },
      { platform: "website", label: "Media Kit", url: "https://example.com/mediakit", sortOrder: 6 },
    ],
    totalScans: 31500,
    todayScans: 185,
    weekScans: 1290,
    monthScans: 5160,
    profileFormData: {
      name: "Mia Creative",
      bio: "Content creator · Lifestyle & travel. Collab enquiries below 🌍✨",
      email: "mia@creativeagency.com",
      location: "Dubai, UAE",
      website: "https://example.com",
      phone: "+971 50 123 4567",
      avatarUrl: "",
    },
  },
  {
    slug: "ad-campaign",
    category: "usecase",
    pageBadge: "Use Case: Ad Campaign",
    username: "fitlifepro",
    name: "FitLife Pro",
    bio: "Transform your body in 90 days. Certified trainers. 24/7 gym access. Join now!",
    location: "Delhi, India",
    avatarInitial: "F",
    avatarColor: "bg-green-600",
    coverFrom: "from-green-600",
    coverTo: "to-emerald-700",
    profileType: "brand",
    themeId: "personal-personal-brand-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Join Now — 50% Off", url: "https://example.com/join", sortOrder: 1 },
      { platform: "whatsapp", label: "Free Consultation", url: "https://wa.me/919876543210", sortOrder: 2 },
      { platform: "phone", label: "Call for Tour", url: "tel:+911123456789", sortOrder: 3 },
      { platform: "instagram", label: "Transformation Stories", url: "https://instagram.com/fitlifepro", sortOrder: 4 },
      { platform: "youtube", label: "Free Workouts", url: "https://youtube.com/@fitlifepro", sortOrder: 5 },
    ],
    totalScans: 11200,
    todayScans: 54,
    weekScans: 378,
    monthScans: 1512,
    profileFormData: {
      name: "FitLife Pro",
      bio: "Transform your body in 90 days. Certified trainers. 24/7 gym access. Join now!",
      email: "hello@fitlifepro.in",
      location: "Delhi, India",
      website: "https://example.com",
      phone: "+91 11 2345 6789",
      avatarUrl: "",
    },
  },
  {
    slug: "commercial-invoice",
    category: "usecase",
    pageBadge: "Use Case: Commercial Invoice",
    username: "nexussolutions",
    name: "Nexus Solutions",
    bio: "Enterprise IT & cloud infrastructure. Trusted by 500+ businesses across South Asia.",
    location: "Pune, India",
    avatarInitial: "N",
    avatarColor: "bg-blue-700",
    coverFrom: "from-blue-700",
    coverTo: "to-slate-800",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "View Invoice Portal", url: "https://example.com/portal", sortOrder: 1 },
      { platform: "email", label: "Accounts Team", url: "mailto:accounts@nexussolutions.in", sortOrder: 2 },
      { platform: "phone", label: "Accounts Helpline", url: "tel:+912012345678", sortOrder: 3 },
      { platform: "whatsapp", label: "Quick Support", url: "https://wa.me/912012345678", sortOrder: 4 },
      { platform: "linkedin", label: "Company LinkedIn", url: "https://linkedin.com/company/nexussolutions", sortOrder: 5 },
    ],
    totalScans: 2840,
    todayScans: 8,
    weekScans: 56,
    monthScans: 224,
    profileFormData: {
      name: "Nexus Solutions",
      bio: "Enterprise IT & cloud infrastructure. Trusted by 500+ businesses across South Asia.",
      email: "accounts@nexussolutions.in",
      location: "Pune, India",
      website: "https://example.com",
      phone: "+91 20 1234 5678",
      avatarUrl: "",
    },
  },
  {
    slug: "highway-hoarding",
    category: "usecase",
    pageBadge: "Use Case: Highway Hoarding",
    username: "megamallhyd",
    name: "MegaMall",
    bio: "350+ stores. Food court. Multiplex. Hypermarket. Visit us this weekend!",
    location: "Hyderabad, India",
    avatarInitial: "M",
    avatarColor: "bg-yellow-600",
    coverFrom: "from-yellow-500",
    coverTo: "to-orange-600",
    profileType: "retail",
    themeId: "retail-fashion-boutique-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Shop & Offers", url: "https://example.com/offers", sortOrder: 1 },
      { platform: "location", label: "Get Directions", url: "https://maps.google.com/?q=Hyderabad+Mall", sortOrder: 2 },
      { platform: "phone", label: "Mall Info", url: "tel:+914012345678", sortOrder: 3 },
      { platform: "instagram", label: "Events & Deals", url: "https://instagram.com/megamallhyd", sortOrder: 4 },
      { platform: "whatsapp", label: "Leasing Enquiry", url: "https://wa.me/914012345678", sortOrder: 5 },
    ],
    totalScans: 18400,
    todayScans: 92,
    weekScans: 644,
    monthScans: 2576,
    profileFormData: {
      name: "MegaMall",
      bio: "350+ stores. Food court. Multiplex. Hypermarket. Visit us this weekend!",
      email: "info@megamall.in",
      location: "Hyderabad, India",
      website: "https://example.com",
      phone: "+91 40 1234 5678",
      avatarUrl: "",
    },
  },
  {
    slug: "retail-carry-bag",
    category: "usecase",
    pageBadge: "Use Case: Retail Carry Bag",
    username: "urbanthreads",
    name: "Urban Threads",
    bio: "Sustainable streetwear. Every bag you carry starts a conversation. Shop our new drop.",
    location: "Mumbai, India",
    avatarInitial: "U",
    avatarColor: "bg-slate-700",
    coverFrom: "from-slate-600",
    coverTo: "to-gray-800",
    profileType: "retail",
    themeId: "retail-fashion-boutique-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "New Drop → Shop", url: "https://example.com/newdrop", sortOrder: 1 },
      { platform: "instagram", label: "Style Inspo", url: "https://instagram.com/urbanthreads_in", sortOrder: 2 },
      { platform: "whatsapp", label: "Exclusive Offers", url: "https://wa.me/919876543210", sortOrder: 3 },
      { platform: "tiktok", label: "TikTok", url: "https://tiktok.com/@urbanthreads", sortOrder: 4 },
      { platform: "facebook", label: "Facebook", url: "https://facebook.com/urbanthreads", sortOrder: 5 },
    ],
    totalScans: 6800,
    todayScans: 31,
    weekScans: 217,
    monthScans: 868,
    profileFormData: {
      name: "Urban Threads",
      bio: "Sustainable streetwear. Every bag you carry starts a conversation. Shop our new drop.",
      email: "hello@urbanthreads.in",
      location: "Mumbai, India",
      website: "https://example.com",
      phone: "+91 98765 43210",
      avatarUrl: "",
    },
  },
  {
    slug: "office-envelope",
    category: "usecase",
    pageBadge: "Use Case: Office Envelope",
    username: "pinnaclecorp",
    name: "Pinnacle Corp",
    bio: "Diversified manufacturing conglomerate. Quality. Innovation. Trust. Est. 1988.",
    location: "Chennai, India",
    avatarInitial: "P",
    avatarColor: "bg-indigo-800",
    coverFrom: "from-indigo-800",
    coverTo: "to-blue-900",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Company Website", url: "https://example.com", sortOrder: 1 },
      { platform: "email", label: "Corporate Enquiry", url: "mailto:enquiry@pinnacle.com", sortOrder: 2 },
      { platform: "linkedin", label: "LinkedIn", url: "https://linkedin.com/company/pinnaclecorp", sortOrder: 3 },
      { platform: "phone", label: "Switchboard", url: "tel:+914412345678", sortOrder: 4 },
      { platform: "location", label: "Head Office", url: "https://maps.google.com/?q=Chennai+Head+Office", sortOrder: 5 },
    ],
    totalScans: 1840,
    todayScans: 4,
    weekScans: 28,
    monthScans: 112,
    profileFormData: {
      name: "Pinnacle Corp",
      bio: "Diversified manufacturing conglomerate. Quality. Innovation. Trust. Est. 1988.",
      email: "enquiry@pinnacle.com",
      location: "Chennai, India",
      website: "https://example.com",
      phone: "+91 44 1234 5678",
      avatarUrl: "",
    },
  },
  // ── 18 USE-CASE BLOCKS ────────────────────────────────
  {
    slug: "restaurant",
    category: "usecase",
    pageBadge: "Use Case: Restaurant",
    username: "spicegardenche",
    name: "Spice Garden",
    bio: "Authentic South Indian cuisine. Scan to see today's specials, reserve a table & order online 🌶",
    location: "Chennai, India",
    avatarInitial: "S",
    avatarColor: "bg-orange-600",
    coverFrom: "from-orange-500",
    coverTo: "to-red-600",
    profileType: "restaurant",
    themeId: "food-fine-dining-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "View Full Menu", url: "https://example.com/menu", sortOrder: 1 },
      { platform: "whatsapp", label: "Reserve a Table", url: "https://wa.me/914412345678", sortOrder: 2 },
      { platform: "phone", label: "Call Us", url: "tel:+914412345678", sortOrder: 3 },
      { platform: "location", label: "Find Us on Map", url: "https://maps.google.com/?q=Chennai", sortOrder: 4 },
      { platform: "instagram", label: "Food Gallery", url: "https://instagram.com/spicegardenche", sortOrder: 5 },
    ],
    totalScans: 9200, todayScans: 41, weekScans: 287, monthScans: 1148,
    profileFormData: { name: "Spice Garden", bio: "Authentic South Indian cuisine.", email: "reservations@spicegarden.in", location: "Chennai, India", website: "https://example.com", phone: "+91 44 1234 5678", avatarUrl: "" },
  },
  {
    slug: "real-estate",
    category: "usecase",
    pageBadge: "Use Case: Real Estate",
    username: "primepropertiesdxb",
    name: "Prime Properties",
    bio: "Luxury homes & investment properties across Dubai. Scan to browse listings & book a site visit.",
    location: "Dubai, UAE",
    avatarInitial: "P",
    avatarColor: "bg-blue-700",
    coverFrom: "from-blue-600",
    coverTo: "to-indigo-800",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Browse Listings", url: "https://example.com/listings", sortOrder: 1 },
      { platform: "whatsapp", label: "Book a Site Visit", url: "https://wa.me/971501234567", sortOrder: 2 },
      { platform: "phone", label: "Call an Agent", url: "tel:+971501234567", sortOrder: 3 },
      { platform: "instagram", label: "Property Gallery", url: "https://instagram.com/primepropertiesdxb", sortOrder: 4 },
      { platform: "linkedin", label: "Company LinkedIn", url: "https://linkedin.com/company/primeprop", sortOrder: 5 },
    ],
    totalScans: 7400, todayScans: 28, weekScans: 196, monthScans: 784,
    profileFormData: { name: "Prime Properties", bio: "Luxury homes & investment properties across Dubai.", email: "hello@primeprop.ae", location: "Dubai, UAE", website: "https://example.com", phone: "+971 50 123 4567", avatarUrl: "" },
  },
  {
    slug: "fitness-studio",
    category: "usecase",
    pageBadge: "Use Case: Fitness Studio",
    username: "ironpeak_gym",
    name: "IronPeak Gym",
    bio: "Transform your body in 90 days. Certified trainers, nutrition plans & 24/7 access. Join now 💪",
    location: "Delhi, India",
    avatarInitial: "I",
    avatarColor: "bg-green-600",
    coverFrom: "from-green-500",
    coverTo: "to-emerald-700",
    profileType: "brand",
    themeId: "personal-personal-brand-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Join Now — 50% Off", url: "https://example.com/join", sortOrder: 1 },
      { platform: "whatsapp", label: "Free Consultation", url: "https://wa.me/919876543210", sortOrder: 2 },
      { platform: "phone", label: "Book a Tour", url: "tel:+911123456789", sortOrder: 3 },
      { platform: "instagram", label: "Transformation Stories", url: "https://instagram.com/ironpeakgym", sortOrder: 4 },
      { platform: "youtube", label: "Free Workouts", url: "https://youtube.com/@ironpeakgym", sortOrder: 5 },
    ],
    totalScans: 11200, todayScans: 54, weekScans: 378, monthScans: 1512,
    profileFormData: { name: "IronPeak Gym", bio: "Transform your body in 90 days.", email: "hello@ironpeakgym.in", location: "Delhi, India", website: "https://example.com", phone: "+91 11 2345 6789", avatarUrl: "" },
  },
  {
    slug: "beauty-salon",
    category: "usecase",
    pageBadge: "Use Case: Beauty Salon",
    username: "glowstudio_sg",
    name: "Glow Studio",
    bio: "Premium hair, skin & nail services. Walk in or book your appointment online 💅",
    location: "Singapore",
    avatarInitial: "G",
    avatarColor: "bg-pink-600",
    coverFrom: "from-pink-500",
    coverTo: "to-fuchsia-700",
    profileType: "brand",
    themeId: "personal-personal-brand-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Book Appointment", url: "https://example.com/book", sortOrder: 1 },
      { platform: "whatsapp", label: "WhatsApp Booking", url: "https://wa.me/6591234567", sortOrder: 2 },
      { platform: "instagram", label: "Our Work Gallery", url: "https://instagram.com/glowstudiosg", sortOrder: 3 },
      { platform: "facebook", label: "Facebook Page", url: "https://facebook.com/glowstudio", sortOrder: 4 },
      { platform: "phone", label: "Call Us", url: "tel:+6591234567", sortOrder: 5 },
    ],
    totalScans: 5800, todayScans: 22, weekScans: 154, monthScans: 616,
    profileFormData: { name: "Glow Studio", bio: "Premium hair, skin & nail services.", email: "hello@glowstudio.sg", location: "Singapore", website: "https://example.com", phone: "+65 9123 4567", avatarUrl: "" },
  },
  {
    slug: "content-creator",
    category: "usecase",
    pageBadge: "Use Case: Creator / YouTuber",
    username: "miacreativeofficial",
    name: "Mia Creative",
    bio: "Lifestyle & travel content. 2.1M TikTok · 850K Instagram. Collab enquiries welcome 🌍✨",
    location: "Dubai, UAE",
    avatarInitial: "M",
    avatarColor: "bg-fuchsia-600",
    coverFrom: "from-fuchsia-500",
    coverTo: "to-pink-700",
    profileType: "celebrity",
    themeId: "personal-influencer-artist-bold",
    themeImageUrl: null,
    links: [
      { platform: "instagram", label: "Instagram (850K)", url: "https://instagram.com/miacreative", sortOrder: 1 },
      { platform: "tiktok", label: "TikTok (2.1M)", url: "https://tiktok.com/@miacreative", sortOrder: 2 },
      { platform: "youtube", label: "YouTube", url: "https://youtube.com/@miacreative", sortOrder: 3 },
      { platform: "whatsapp", label: "Collab Enquiry", url: "https://wa.me/971501234567", sortOrder: 4 },
      { platform: "email", label: "Business Email", url: "mailto:mia@creativeagency.com", sortOrder: 5 },
      { platform: "website", label: "Media Kit", url: "https://example.com/mediakit", sortOrder: 6 },
    ],
    totalScans: 31500, todayScans: 185, weekScans: 1290, monthScans: 5160,
    profileFormData: { name: "Mia Creative", bio: "Lifestyle & travel content creator.", email: "mia@creativeagency.com", location: "Dubai, UAE", website: "https://example.com", phone: "+971 50 123 4567", avatarUrl: "" },
  },
  {
    slug: "doctor",
    category: "usecase",
    pageBadge: "Use Case: Doctor / Clinic",
    username: "drsharma_cardio",
    name: "Dr. Ravi Sharma",
    bio: "Cardiologist · 20 years experience. Scan to book a consultation, view my credentials & patient portal.",
    location: "Mumbai, India",
    avatarInitial: "R",
    avatarColor: "bg-teal-600",
    coverFrom: "from-teal-500",
    coverTo: "to-cyan-700",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Book Consultation", url: "https://example.com/book", sortOrder: 1 },
      { platform: "phone", label: "Clinic Helpline", url: "tel:+912212345678", sortOrder: 2 },
      { platform: "whatsapp", label: "WhatsApp Clinic", url: "https://wa.me/912212345678", sortOrder: 3 },
      { platform: "email", label: "Patient Portal", url: "mailto:appointments@drsharma.in", sortOrder: 4 },
      { platform: "location", label: "Clinic Address", url: "https://maps.google.com/?q=Bandra+Mumbai", sortOrder: 5 },
    ],
    totalScans: 4200, todayScans: 14, weekScans: 98, monthScans: 392,
    profileFormData: { name: "Dr. Ravi Sharma", bio: "Cardiologist · 20 years experience.", email: "appointments@drsharma.in", location: "Mumbai, India", website: "https://example.com", phone: "+91 22 1234 5678", avatarUrl: "" },
  },
  {
    slug: "retail-store",
    category: "usecase",
    pageBadge: "Use Case: Retail Store",
    username: "modastoremiln",
    name: "Moda Store",
    bio: "Contemporary fashion for the modern wardrobe. Step inside & discover your style. Milan's finest.",
    location: "Milan, Italy",
    avatarInitial: "M",
    avatarColor: "bg-slate-800",
    coverFrom: "from-slate-700",
    coverTo: "to-gray-900",
    profileType: "retail",
    themeId: "retail-fashion-boutique-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Shop Online", url: "https://example.com/shop", sortOrder: 1 },
      { platform: "whatsapp", label: "Style Enquiry", url: "https://wa.me/390123456789", sortOrder: 2 },
      { platform: "instagram", label: "New Arrivals", url: "https://instagram.com/modastore", sortOrder: 3 },
      { platform: "location", label: "Store Map", url: "https://maps.google.com/?q=Milan", sortOrder: 4 },
      { platform: "phone", label: "Call Store", url: "tel:+390123456789", sortOrder: 5 },
    ],
    totalScans: 5120, todayScans: 28, weekScans: 192, monthScans: 768,
    profileFormData: { name: "Moda Store", bio: "Contemporary fashion for the modern wardrobe.", email: "info@modastore.it", location: "Milan, Italy", website: "https://example.com", phone: "+39 012 345 6789", avatarUrl: "" },
  },
  {
    slug: "event-manager",
    category: "usecase",
    pageBadge: "Use Case: Event Manager",
    username: "techconf2026hyd",
    name: "TechConf 2026",
    bio: "India's largest tech conference. 80+ speakers · 5,000 attendees · June 14–16, Hyderabad.",
    location: "Hyderabad, India",
    avatarInitial: "T",
    avatarColor: "bg-indigo-700",
    coverFrom: "from-indigo-600",
    coverTo: "to-blue-800",
    profileType: "event",
    themeId: "services-event-planner-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Conference Schedule", url: "https://example.com/schedule", sortOrder: 1 },
      { platform: "whatsapp", label: "Attendee Support", url: "https://wa.me/914012345678", sortOrder: 2 },
      { platform: "location", label: "Venue Map", url: "https://maps.google.com/?q=HITEX+Hyderabad", sortOrder: 3 },
      { platform: "instagram", label: "Event Updates", url: "https://instagram.com/techconf2026", sortOrder: 4 },
      { platform: "linkedin", label: "Event Page", url: "https://linkedin.com/events/techconf2026", sortOrder: 5 },
    ],
    totalScans: 7840, todayScans: 62, weekScans: 430, monthScans: 1720,
    profileFormData: { name: "TechConf 2026", bio: "India's largest tech conference.", email: "info@techconf.in", location: "Hyderabad, India", website: "https://example.com", phone: "+91 40 1234 5678", avatarUrl: "" },
  },
  {
    slug: "freelancer",
    category: "usecase",
    pageBadge: "Use Case: Freelancer",
    username: "jameschenapac",
    name: "James Chen",
    bio: "Regional Sales Director & Freelance Consultant. Building partnerships that drive growth across APAC.",
    location: "Singapore",
    avatarInitial: "J",
    avatarColor: "bg-blue-600",
    coverFrom: "from-blue-500",
    coverTo: "to-indigo-700",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "linkedin", label: "LinkedIn", url: "https://linkedin.com/in/jameschenapac", sortOrder: 1 },
      { platform: "phone", label: "+65 9876 5432", url: "tel:+6598765432", sortOrder: 2 },
      { platform: "email", label: "Email Me", url: "mailto:james.chen@example.com", sortOrder: 3 },
      { platform: "whatsapp", label: "WhatsApp", url: "https://wa.me/6598765432", sortOrder: 4 },
      { platform: "website", label: "Portfolio", url: "https://example.com/james", sortOrder: 5 },
    ],
    totalScans: 4800, todayScans: 12, weekScans: 84, monthScans: 340,
    profileFormData: { name: "James Chen", bio: "Regional Sales Director & Freelance Consultant.", email: "james.chen@example.com", location: "Singapore", website: "https://example.com/james", phone: "+65 9876 5432", avatarUrl: "" },
  },
  {
    slug: "consultant",
    category: "usecase",
    pageBadge: "Use Case: Consultant",
    username: "drpriyaconsults",
    name: "Dr. Priya Sharma",
    bio: "Management Consultant & Executive Coach. Helping leaders build high-performance teams since 2008.",
    location: "Mumbai, India",
    avatarInitial: "P",
    avatarColor: "bg-teal-600",
    coverFrom: "from-teal-600",
    coverTo: "to-emerald-700",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "linkedin", label: "LinkedIn Profile", url: "https://linkedin.com/in/drpriyasharma", sortOrder: 1 },
      { platform: "email", label: "Book a Session", url: "mailto:priya@sharmacoach.com", sortOrder: 2 },
      { platform: "phone", label: "Call / WhatsApp", url: "tel:+919876543210", sortOrder: 3 },
      { platform: "website", label: "My Website", url: "https://example.com", sortOrder: 4 },
      { platform: "twitter", label: "X (Twitter)", url: "https://x.com/drpriyasharma", sortOrder: 5 },
    ],
    totalScans: 6200, todayScans: 14, weekScans: 98, monthScans: 390,
    profileFormData: { name: "Dr. Priya Sharma", bio: "Management Consultant & Executive Coach.", email: "priya@sharmacoach.com", location: "Mumbai, India", website: "https://example.com", phone: "+91 98765 43210", avatarUrl: "" },
  },
  {
    slug: "hotel",
    category: "usecase",
    pageBadge: "Use Case: Hotel",
    username: "grandazureresort",
    name: "Grand Azure Resort",
    bio: "5-star beachfront resort. Scan to book your stay, explore dining & request concierge services. 🌊",
    location: "Bali, Indonesia",
    avatarInitial: "G",
    avatarColor: "bg-cyan-700",
    coverFrom: "from-cyan-500",
    coverTo: "to-blue-700",
    profileType: "brand",
    themeId: "personal-personal-brand-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Book a Room", url: "https://example.com/book", sortOrder: 1 },
      { platform: "whatsapp", label: "Concierge Services", url: "https://wa.me/6281234567890", sortOrder: 2 },
      { platform: "phone", label: "Reception", url: "tel:+6281234567890", sortOrder: 3 },
      { platform: "instagram", label: "Resort Gallery", url: "https://instagram.com/grandazureresort", sortOrder: 4 },
      { platform: "location", label: "Resort Location", url: "https://maps.google.com/?q=Bali+Resort", sortOrder: 5 },
    ],
    totalScans: 12400, todayScans: 58, weekScans: 406, monthScans: 1624,
    profileFormData: { name: "Grand Azure Resort", bio: "5-star beachfront resort in Bali.", email: "reservations@grandazure.com", location: "Bali, Indonesia", website: "https://example.com", phone: "+62 812 3456 7890", avatarUrl: "" },
  },
  {
    slug: "cafe",
    category: "usecase",
    pageBadge: "Use Case: Café / Coffee",
    username: "cornerbrewatx",
    name: "Corner Brew",
    bio: "Your neighbourhood's favourite coffee spot. Specialty roasts, all-day brunch. Open 7am–9pm ☕",
    location: "Austin, TX",
    avatarInitial: "C",
    avatarColor: "bg-amber-800",
    coverFrom: "from-amber-600",
    coverTo: "to-orange-800",
    profileType: "restaurant",
    themeId: "food-fine-dining-bold",
    themeImageUrl: null,
    links: [
      { platform: "phone", label: "Call to Reserve", url: "tel:+15125551234", sortOrder: 1 },
      { platform: "whatsapp", label: "WhatsApp Us", url: "https://wa.me/15125551234", sortOrder: 2 },
      { platform: "location", label: "Get Directions", url: "https://maps.google.com/?q=Austin+TX", sortOrder: 3 },
      { platform: "website", label: "Our Menu", url: "https://example.com/menu", sortOrder: 4 },
      { platform: "instagram", label: "Instagram", url: "https://instagram.com/cornerbrewatx", sortOrder: 5 },
    ],
    totalScans: 3210, todayScans: 18, weekScans: 112, monthScans: 420,
    profileFormData: { name: "Corner Brew", bio: "Your neighbourhood's favourite coffee spot.", email: "hi@cornerbrew.com", location: "Austin, TX", website: "https://example.com", phone: "+1 512 555 1234", avatarUrl: "" },
  },
  {
    slug: "pharmacy",
    category: "usecase",
    pageBadge: "Use Case: Pharmacy",
    username: "healthfirst_rx",
    name: "HealthFirst Pharmacy",
    bio: "Your trusted community pharmacy. Prescription refills, health checks & home delivery. Est. 2001.",
    location: "Toronto, Canada",
    avatarInitial: "H",
    avatarColor: "bg-sky-600",
    coverFrom: "from-sky-500",
    coverTo: "to-blue-700",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "phone", label: "Prescription Line", url: "tel:+14161234567", sortOrder: 1 },
      { platform: "whatsapp", label: "Refill Request", url: "https://wa.me/14161234567", sortOrder: 2 },
      { platform: "website", label: "Book Health Check", url: "https://example.com/book", sortOrder: 3 },
      { platform: "email", label: "Email Pharmacy", url: "mailto:rx@healthfirst.ca", sortOrder: 4 },
      { platform: "location", label: "Find Us", url: "https://maps.google.com/?q=Toronto+Pharmacy", sortOrder: 5 },
    ],
    totalScans: 3600, todayScans: 16, weekScans: 112, monthScans: 448,
    profileFormData: { name: "HealthFirst Pharmacy", bio: "Your trusted community pharmacy.", email: "rx@healthfirst.ca", location: "Toronto, Canada", website: "https://example.com", phone: "+1 416 123 4567", avatarUrl: "" },
  },
  {
    slug: "education",
    category: "usecase",
    pageBadge: "Use Case: Education",
    username: "apexacademy",
    name: "Apex Academy",
    bio: "Expert coaching for IIT-JEE, NEET & Board exams. 10,000+ students · 95% selection rate 📚",
    location: "Hyderabad, India",
    avatarInitial: "A",
    avatarColor: "bg-purple-700",
    coverFrom: "from-purple-600",
    coverTo: "to-violet-800",
    profileType: "brand",
    themeId: "personal-personal-brand-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Enrol Now", url: "https://example.com/enrol", sortOrder: 1 },
      { platform: "whatsapp", label: "Free Counselling", url: "https://wa.me/914012345678", sortOrder: 2 },
      { platform: "phone", label: "Admissions", url: "tel:+914012345678", sortOrder: 3 },
      { platform: "youtube", label: "Free Lectures", url: "https://youtube.com/@apexacademy", sortOrder: 4 },
      { platform: "instagram", label: "Student Results", url: "https://instagram.com/apexacademy", sortOrder: 5 },
    ],
    totalScans: 9800, todayScans: 44, weekScans: 308, monthScans: 1232,
    profileFormData: { name: "Apex Academy", bio: "Expert coaching for IIT-JEE, NEET & Board exams.", email: "admissions@apexacademy.in", location: "Hyderabad, India", website: "https://example.com", phone: "+91 40 1234 5678", avatarUrl: "" },
  },
  {
    slug: "photographer",
    category: "usecase",
    pageBadge: "Use Case: Photographer",
    username: "lensbylara",
    name: "Lens by Lara",
    bio: "Wedding & portrait photographer based in Barcelona. Booking 2026–2027. Let's create magic 📸",
    location: "Barcelona, Spain",
    avatarInitial: "L",
    avatarColor: "bg-pink-700",
    coverFrom: "from-pink-600",
    coverTo: "to-rose-800",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "View Portfolio", url: "https://example.com/portfolio", sortOrder: 1 },
      { platform: "instagram", label: "Instagram Gallery", url: "https://instagram.com/lensbylara", sortOrder: 2 },
      { platform: "whatsapp", label: "Check Availability", url: "https://wa.me/34612345678", sortOrder: 3 },
      { platform: "email", label: "Booking Enquiry", url: "mailto:lara@lensbylara.com", sortOrder: 4 },
      { platform: "youtube", label: "Behind the Scenes", url: "https://youtube.com/@lensbylara", sortOrder: 5 },
    ],
    totalScans: 6400, todayScans: 24, weekScans: 168, monthScans: 672,
    profileFormData: { name: "Lens by Lara", bio: "Wedding & portrait photographer.", email: "lara@lensbylara.com", location: "Barcelona, Spain", website: "https://example.com", phone: "+34 612 345 678", avatarUrl: "" },
  },
  {
    slug: "taxi-transport",
    category: "usecase",
    pageBadge: "Use Case: Taxi / Transport",
    username: "swiftrides_blr",
    name: "Swift Rides",
    bio: "Safe, reliable cab & corporate transport. Book a ride, track your driver & pay instantly. 🚕",
    location: "Bangalore, India",
    avatarInitial: "S",
    avatarColor: "bg-yellow-600",
    coverFrom: "from-yellow-500",
    coverTo: "to-amber-700",
    profileType: "brand",
    themeId: "personal-personal-brand-bold",
    themeImageUrl: null,
    links: [
      { platform: "phone", label: "Book a Ride", url: "tel:+918012345678", sortOrder: 1 },
      { platform: "whatsapp", label: "WhatsApp Booking", url: "https://wa.me/918012345678", sortOrder: 2 },
      { platform: "website", label: "Corporate Packages", url: "https://example.com/corporate", sortOrder: 3 },
      { platform: "location", label: "Pick-up Point", url: "https://maps.google.com/?q=Bangalore+Airport", sortOrder: 4 },
      { platform: "instagram", label: "Our Fleet", url: "https://instagram.com/swiftridesblr", sortOrder: 5 },
    ],
    totalScans: 5200, todayScans: 34, weekScans: 238, monthScans: 952,
    profileFormData: { name: "Swift Rides", bio: "Safe, reliable cab & corporate transport.", email: "hello@swiftrides.in", location: "Bangalore, India", website: "https://example.com", phone: "+91 80 1234 5678", avatarUrl: "" },
  },
  {
    slug: "manufacturer",
    category: "usecase",
    pageBadge: "Use Case: Manufacturer",
    username: "pinnaclecorpind",
    name: "Pinnacle Corp",
    bio: "Diversified manufacturing conglomerate. Quality. Innovation. Trust. Trusted by 1,200+ partners. Est. 1988.",
    location: "Chennai, India",
    avatarInitial: "P",
    avatarColor: "bg-indigo-800",
    coverFrom: "from-indigo-800",
    coverTo: "to-slate-900",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Company Website", url: "https://example.com", sortOrder: 1 },
      { platform: "email", label: "Corporate Enquiry", url: "mailto:enquiry@pinnacle.com", sortOrder: 2 },
      { platform: "linkedin", label: "LinkedIn", url: "https://linkedin.com/company/pinnaclecorp", sortOrder: 3 },
      { platform: "phone", label: "Switchboard", url: "tel:+914412345678", sortOrder: 4 },
      { platform: "location", label: "Head Office", url: "https://maps.google.com/?q=Chennai+Head+Office", sortOrder: 5 },
    ],
    totalScans: 2840, todayScans: 8, weekScans: 56, monthScans: 224,
    profileFormData: { name: "Pinnacle Corp", bio: "Diversified manufacturing conglomerate.", email: "enquiry@pinnacle.com", location: "Chennai, India", website: "https://example.com", phone: "+91 44 1234 5678", avatarUrl: "" },
  },
  {
    slug: "charity-ngo",
    category: "usecase",
    pageBadge: "Use Case: Charity / NGO",
    username: "hopebridgefdn",
    name: "HopeBridge Foundation",
    bio: "Empowering underprivileged communities through education, healthcare & livelihood. Scan to donate or volunteer. 🤝",
    location: "Nairobi, Kenya",
    avatarInitial: "H",
    avatarColor: "bg-green-700",
    coverFrom: "from-green-600",
    coverTo: "to-emerald-800",
    profileType: "professional",
    themeId: "professional-business-consultant-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Donate Now", url: "https://example.com/donate", sortOrder: 1 },
      { platform: "whatsapp", label: "Volunteer Sign-up", url: "https://wa.me/254712345678", sortOrder: 2 },
      { platform: "email", label: "Contact Us", url: "mailto:info@hopebridge.org", sortOrder: 3 },
      { platform: "instagram", label: "Our Impact Stories", url: "https://instagram.com/hopebridgefdn", sortOrder: 4 },
      { platform: "youtube", label: "Documentaries", url: "https://youtube.com/@hopebridgefdn", sortOrder: 5 },
    ],
    totalScans: 8100, todayScans: 36, weekScans: 252, monthScans: 1008,
    profileFormData: { name: "HopeBridge Foundation", bio: "Empowering communities through education & healthcare.", email: "info@hopebridge.org", location: "Nairobi, Kenya", website: "https://example.com", phone: "+254 712 345 678", avatarUrl: "" },
  },
  // ── ORIGINAL E-COMMERCE PARCEL ─────────────────────────
  {
    slug: "ecommerce-parcel",
    category: "usecase",
    pageBadge: "Use Case: E-Commerce Parcel",
    username: "quickshipstore",
    name: "QuickShip Store",
    bio: "Your order has arrived! Scan to register warranty, track returns & get exclusive offers.",
    location: "Bengaluru, India",
    avatarInitial: "Q",
    avatarColor: "bg-emerald-600",
    coverFrom: "from-emerald-600",
    coverTo: "to-teal-700",
    profileType: "ecommerce",
    themeId: "retail-fashion-boutique-bold",
    themeImageUrl: null,
    links: [
      { platform: "website", label: "Register Warranty", url: "https://example.com/warranty", sortOrder: 1 },
      { platform: "whatsapp", label: "Track / Return", url: "https://wa.me/918012345678", sortOrder: 2 },
      { platform: "email", label: "Customer Care", url: "mailto:care@quickship.in", sortOrder: 3 },
      { platform: "website", label: "Shop Again — 10% Off", url: "https://example.com/shop", sortOrder: 4 },
      { platform: "instagram", label: "Instagram", url: "https://instagram.com/quickshipstore", sortOrder: 5 },
    ],
    totalScans: 14200,
    todayScans: 78,
    weekScans: 546,
    monthScans: 2184,
    profileFormData: {
      name: "QuickShip Store",
      bio: "Your order has arrived! Scan to register warranty, track returns & get exclusive offers.",
      email: "care@quickship.in",
      location: "Bengaluru, India",
      website: "https://example.com",
      phone: "+91 80 1234 5678",
      avatarUrl: "",
    },
  },
];

export function getDemoProfile(slug: string): DemoProfileData | undefined {
  return DEMO_PROFILES.find((p) => p.slug === slug);
}
